/**
 * HeaderSearch
 * ======================================
 * - toggle class on body
 * - add class to html attr [data-toggle]
 */

 const ELEMENTS = '.js-ToggleHeaderSearch'
 const TOGGLE_CLASS = 'search-is-open'

 class ToggleBodyClass {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS)

     if (!this.elements.length) {
       return false
     }

     this.field = document.querySelector('.header-search__field-input')
     this.fieldClose = document.querySelector('.header-search__close')
     this.livesearch = document.querySelector('.header-search__in.search-autocomplete')

     this.elements.forEach(el => {
       el.addEventListener('click', this.toggle, false)
     })

     this.fieldClose.addEventListener('click', this.close, false)
   }

   close = (e) => {
    document.body.classList.remove(TOGGLE_CLASS)

    this.livesearch.classList.remove('livesearch-active')

    e.preventDefault()
   }

   toggle = () => {
     document.body.classList.toggle(TOGGLE_CLASS)

     if (document.body.classList.contains(TOGGLE_CLASS)) {
      this.field.focus()
     } else {
      this.field.blur()
     }
   }
 }

 new ToggleBodyClass()
